import { InvokeApi } from "../../Utils/InvokeApi";

export const CreateUser = async (data) => {
  const requestObj = {
    path: `/user/create`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};

export const UpdateUser = async (userId, data) => {
    const requestObj = {
      path: `/user/${userId}`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      postData: data,
    };
    return InvokeApi(requestObj);
  };
  

export const GetUsers = async (data) => {
  const { page, limit, key, value } = data;
  const params = new URLSearchParams();
  if (data !== false) {
    params.set('page', page.toString());
    params.set('limit', limit.toString());
  // Only include key and value if both are provided
  if (key && value) {
    params.set('key', key);
    params.set('value', value);
  }
}
  let paramQuery = data !== false ? params.toString() : ""
  const requestObj = {
    path: `/user/get?${paramQuery}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};

export const DeleteUser = async (userId) => {
    const requestObj = {
      path: `/user/${userId}`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        "Content-Type": "application/json",
      },
    };
    return InvokeApi(requestObj);
};

